/**
 * Раскладка по ширине экрана и тип указателя (docs/08-mobile-roadmap.md, M0).
 *
 * Границы совпадают с брейкпоинтами Tailwind 4: `sm` = 40rem, `lg` = 64rem.
 * Классы `max-sm:` и хук `useIsPhone` обязаны переключаться на одной и той
 * же ширине, иначе на границе вёрстка и поведение разойдутся.
 *
 * Хук нужен только там, где меняется ПОВЕДЕНИЕ: сенсоры перетаскивания,
 * нижний лист вместо поповера, режим «только просмотр». Если меняется
 * лишь вид — достаточно классов `max-sm:` / `max-lg:`.
 */

import { useSyncExternalStore } from "react";

/** Телефон: уже 640 px. */
export const PHONE_QUERY = "(width < 40rem)";
/** Планшет: 640–1023 px. */
export const TABLET_QUERY = "(40rem <= width < 64rem)";
/** Основной указатель — палец: цели касания крупнее, перетаскивание с задержкой. */
export const COARSE_POINTER_QUERY = "(pointer: coarse)";

function mediaList(query: string): MediaQueryList | null {
  // jsdom не реализует matchMedia: в тестах раскладка — десктопная.
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return null;
  return window.matchMedia(query);
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = mediaList(query);
      if (list === null) return () => undefined;
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => mediaList(query)?.matches ?? false,
    () => false,
  );
}

export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_QUERY);
}

export function useIsTablet(): boolean {
  return useMediaQuery(TABLET_QUERY);
}

export function useIsCoarsePointer(): boolean {
  return useMediaQuery(COARSE_POINTER_QUERY);
}
